var map = {
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings1.jpg": 2179,
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings2.jpg": 372,
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings3.jpg": 8897,
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings4.jpg": 5986,
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings5.jpg": 2335,
	"./PartyMassWork/DeliveringBlessings/DeliveringBlessings6.jpg": 1024,
	"./PartyMassWork/PartyBranch/PartyBranch1.jpg": 9335,
	"./PartyMassWork/PartyBranch/PartyBranch2.jpg": 1880,
	"./PartyMassWork/PartyBranch/PartyBranch3.jpg": 9749,
	"./PartyMassWork/PartyBranch/PartyBranch4.jpg": 7278,
	"./PartyMassWork/SendingBlessingsMC/SendingBlessingsMC1.png": 1305,
	"./PartyMassWork/SendingBlessingsMC/SendingBlessingsMC2.jpg": 7830,
	"./PartyMassWork/SendingBlessingsMC/SendingBlessingsMC3.png": 8875,
	"./PartyMassWork/SymposiumMC/SymposiumMC1.jpg": 1591,
	"./PartyMassWork/SymposiumMC/SymposiumMC2.jpg": 2664,
	"./PartyMassWork/title.png": 1231,
	"./appheader/logo-white.png": 5115,
	"./appheader/logo.png": 2827,
	"./arrow left.png": 4629,
	"./arrow right.png": 1430,
	"./bgc-ex.jpg": 8565,
	"./homepage/about-us-pic1.png": 6622,
	"./homepage/innovation/in-pic1.png": 9511,
	"./homepage/innovation/in-pic2.png": 508,
	"./homepage/news/news-pic1.jpg": 6211,
	"./homepage/partnerLogo-bgc.png": 382,
	"./homepage/spec-pics/spec-pic1.png": 8717,
	"./homepage/spec-pics/spec-pic2.png": 8038,
	"./homepage/spec-pics/spec-pic3.png": 6127,
	"./homepage/spec-pics/spec-pic4.jpg": 436,
	"./homepage/spec-pics/spec-pic5.jpg": 8481,
	"./inno/inno1.jpg": 9080,
	"./inno/inno2.png": 9528,
	"./logo-example.png": 2227,
	"./logo.png": 2806,
	"./product-ex.png": 354,
	"./product-example.jpg": 3211,
	"./qsyl-logo.png": 6230,
	"./search.png": 4319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;